// Configuration API sécurisée
// Les appels passent par Supabase Edge Function (clé cachée côté serveur)

const SUPABASE_URL = 'https://ififowdcasczwlydunfj.supabase.co';

export const API = {
  // Proxy unique pour tous les appels OpenAI
  openaiProxy: `${SUPABASE_URL}/functions/v1/openai-proxy`,
};

export default API;
